var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 26,
    fill: "url(#paint0_linear_1864_697)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3877 24.9022C42.4047 25.1492 42.4047 25.3962 42.4047 25.6454C42.4047 33.2406 36.6339 42.0001 26.0817 42.0001V41.9955C22.9646 42.0001 19.9122 41.1054 17.2881 39.4187C17.7413 39.4733 18.1969 39.5006 18.6535 39.5017C21.2368 39.504 23.7462 38.6356 25.7784 37.0364C23.3236 36.9898 21.1709 35.3861 20.4189 33.0448C21.2788 33.211 22.1649 33.1768 23.0089 32.9458C20.3325 32.404 18.407 30.0479 18.407 27.3117C18.407 27.2867 18.407 27.2628 18.407 27.2389C19.2045 27.6839 20.0974 27.9309 21.0107 27.9582C18.49 26.2703 17.7129 22.9104 19.2352 20.2834C22.1478 23.8744 26.4453 26.0575 31.0585 26.2885C30.5962 24.2921 31.2278 22.2001 32.7182 20.7968C35.0288 18.6205 38.6628 18.7321 40.8348 21.046C42.1196 20.7922 43.351 20.3199 44.4779 19.6506C44.0496 20.9811 43.1533 22.1114 41.956 22.8296C43.0931 22.6953 44.2041 22.3902 45.2504 21.9247C44.4802 23.0811 43.51 24.0884 42.3877 24.9022Z",
    fill: "#1D9BF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1864_697",
    x1: -23.8313,
    y1: 18.0425,
    x2: 35.502,
    y2: 71.4532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.13c651452659c5e6d74de7f9cfbde745.svg";
export { ForwardRef as ReactComponent };